"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.phoneFormatter = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _libphonenumberJs = require("libphonenumber-js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("./styles.scss"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var NOT_AVAILABLE = 'N/A';
var phoneFormatter = function phoneFormatter(phoneValue, internationalPhoneSupportEnabled) {
  var phoneNum = '';
  var phone = '';
  if (!internationalPhoneSupportEnabled) {
    phoneNum = (0, _libphonenumberJs.parsePhoneNumberFromString)(phoneValue, 'US');
    phone = phoneNum ? phoneNum.formatNational() : phoneValue;
  } else {
    var phoneVal = phoneValue.includes('+') ? phoneValue : "+".concat(phoneValue);
    phoneNum = (0, _libphonenumberJs.parsePhoneNumberFromString)(phoneVal);
    phone = phoneNum ? phoneNum.formatInternational() : phoneVal;
  }
  return phone;
};
exports.phoneFormatter = phoneFormatter;
var PhoneNumberView = function PhoneNumberView(props) {
  var outdated = props.outdated,
    clickable = props.clickable,
    phoneNumber = props.phoneNumber,
    formatter = props.formatter,
    className = props.className,
    internationalPhoneSupportEnabled = props.internationalPhoneSupportEnabled;
  var renderPhoneByType = function renderPhoneByType(phone) {
    if (clickable) {
      return /*#__PURE__*/_react.default.createElement("a", {
        className: outdated && 'outdated',
        href: "tel:".concat(phone)
      }, phone);
    }
    if (outdated) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "outdated"
      }, phone);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, phone);
  };
  var renderPhoneNumber = function renderPhoneNumber() {
    if (!phoneNumber) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, NOT_AVAILABLE);
    }
    if (formatter) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, formatter(phoneNumber));
    }
    var phone = phoneFormatter(phoneNumber, internationalPhoneSupportEnabled);
    return renderPhoneByType(phone);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_styles.default['phone-view-wrapper'], " phone-wrapper")
  }, renderPhoneNumber());
};
PhoneNumberView.propTypes = {
  outdated: _propTypes.default.bool,
  clickable: _propTypes.default.bool,
  phoneNumber: _propTypes.default.string,
  className: _propTypes.default.string,
  formatter: _propTypes.default.func,
  internationalPhoneSupportEnabled: _propTypes.default.bool
};
PhoneNumberView.defaultProps = {
  outdated: false,
  clickable: false,
  phoneNumber: null,
  className: '',
  formatter: null,
  internationalPhoneSupportEnabled: false
};
var _default = PhoneNumberView;
exports.default = _default;